// import React from "react";
// import { Box, Typography, IconButton } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// const PreviewFeatures = ({ data, onEdit, onDelete }) => {
//   const handleCardClick = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (onEdit) {
//       onEdit("features", index);
//     }
//   };

//   const handleDelete = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (window.confirm("Are you sure you want to delete this feature?")) {
//       if (onDelete) {
//         onDelete("features", index);
//       }
//     }
//   };

//   return (
//     <Box onClick={(e) => e.stopPropagation()}>
//       <Typography
//         variant="caption"
//         color="text.secondary"
//         fontWeight={600}
//         display="block"
//         mb={2}
//       >
//         {data.sectionTitle}
//       </Typography>

//       <Box display="flex" gap={2} flexWrap="wrap">
//         {data.items
//           .filter((i) => i.title)
//           .map((feature, i) => (
//             <Box
//               key={i}
//               onClick={(e) => handleCardClick(i, e)}
//               sx={{
//                 flex: "0 0 200px",
//                 background: "rgba(255,255,255,0.05)",
//                 border: "1px solid rgba(255,255,255,0.1)",
//                 borderRadius: "10px",
//                 p: 2,
//                 cursor: "pointer",
//                 transition: "all 0.2s",
//                 position: "relative",
//                 "&:hover": {
//                   background: "rgba(255,255,255,0.08)",
//                   borderColor: "#3b82f6",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
//                 },
//               }}
//             >
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: 8,
//                   right: 8,
//                   display: "flex",
//                   gap: 0.5,
//                 }}
//               >
//                 <IconButton
//                   size="small"
//                   onClick={(e) => handleDelete(i, e)}
//                   sx={{
//                     width: 24,
//                     height: 24,
//                     background: "rgba(244,67,54,0.1)",
//                     color: "#f44336",
//                     "&:hover": {
//                       background: "rgba(244,67,54,0.2)",
//                     },
//                   }}
//                 >
//                   <DeleteOutlineIcon sx={{ fontSize: 14 }} />
//                 </IconButton>
//                 <IconButton
//                   size="small"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleCardClick(i, e);
//                   }}
//                   sx={{
//                     width: 24,
//                     height: 24,
//                     background: "rgba(59,130,246,0.1)",
//                     color: "#3b82f6",
//                     "&:hover": {
//                       background: "rgba(59,130,246,0.2)",
//                     },
//                   }}
//                 >
//                   <EditIcon sx={{ fontSize: 14 }} />
//                 </IconButton>
//               </Box>

//               <Box display="flex" flexDirection="column" gap={1}>
//                 {/* Icon */}
//                 {feature.icon ? (
//                   <Box
//                     component="img"
//                     src={feature.icon}
//                     sx={{
//                       width: 40,
//                       height: 40,
//                       borderRadius: "8px",
//                       objectFit: "cover",
//                     }}
//                   />
//                 ) : (
//                   <Box
//                     sx={{
//                       width: 40,
//                       height: 40,
//                       borderRadius: "8px",
//                       background: "rgba(59,130,246,0.1)",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <Typography fontSize={20}>⚡</Typography>
//                   </Box>
//                 )}

//                 {/* Title */}
//                 <Typography variant="subtitle2" fontWeight={600} noWrap>
//                   {feature.title}
//                 </Typography>

//                 {/* Description */}
//                 {feature.description && (
//                   <Typography
//                     variant="caption"
//                     color="text.secondary"
//                     sx={{
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       display: "-webkit-box",
//                       WebkitLineClamp: 2,
//                       WebkitBoxOrient: "vertical",
//                     }}
//                   >
//                     {feature.description}
//                   </Typography>
//                 )}

//                 {/* Tags */}
//                 {feature.tags && (
//                   <Typography
//                     variant="caption"
//                     color="#3b82f6"
//                     sx={{ fontSize: "9px" }}
//                   >
//                     {feature.tags}
//                   </Typography>
//                 )}
//               </Box>
//             </Box>
//           ))}

//         {!data.items.some((i) => i.title) && (
//           <Typography variant="caption" color="text.secondary">
//             No features added yet
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default PreviewFeatures;


import React from "react";
import { Box, Typography } from "@mui/material";
import SummaryCard from "../shared/SummaryCard";

/**
 * PreviewFeatures
 *
 * Props:
 *  data      { sectionTitle, items[] }
 *  onEdit    fn(sectionKey, index)
 *  onDelete  fn(sectionKey, index)
 */
const PreviewFeatures = ({ data, onEdit, onDelete }) => (
  <Box onClick={(e) => e.stopPropagation()}>
    {data.sectionTitle && (
      <Typography
        variant="caption"
        color="text.secondary"
        fontWeight={600}
        display="block"
        mb={2}
      >
        {data.sectionTitle}
      </Typography>
    )}

    <Box display="flex" gap={2} flexWrap="wrap">
      {data.items.filter((i) => i.title).length === 0 ? (
        <Typography variant="caption" color="text.secondary">
          No features added yet
        </Typography>
      ) : (
        data.items
          .filter((i) => i.title)
          .map((feature, i) => (
            <SummaryCard
              key={i}
              width={200}
              onClick={() => onEdit?.("features", i)}
              onDelete={() => onDelete?.("features", i)}
            >
              {/* Icon */}
              {feature.icon ? (
                <Box
                  component="img"
                  src={feature.icon}
                  sx={{ width: 36, height: 36, borderRadius: "8px", objectFit: "cover", mb: 1 }}
                />
              ) : (
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "8px",
                    background: "rgba(59,130,246,0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 1,
                  }}
                >
                  <Typography fontSize={18}>⚡</Typography>
                </Box>
              )}

              <Typography variant="subtitle2" fontWeight={600} noWrap mb={0.5}>
                {feature.title}
              </Typography>

              {feature.description && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {feature.description}
                </Typography>
              )}

              {feature.tags && (
                <Typography
                  variant="caption"
                  color="#3b82f6"
                  sx={{ fontSize: "9px", display: "block", mt: 0.5 }}
                >
                  {feature.tags}
                </Typography>
              )}
            </SummaryCard>
          ))
      )}
    </Box>
  </Box>
);

export default PreviewFeatures;